import type {ApiGwResponse} from '$types/apigw'
import type {ValueOf} from 'next/constants'

export const MEMBER_STATUS = {
    SUCCESS: 'success',
    NOT_AGREED: 'notagreed',
    NONE: 'none',
} as const

export type MemberStatusType = (typeof MEMBER_STATUS)[keyof typeof MEMBER_STATUS]

export interface MemberInfo {
    imageUrl: string | null
    nickName: string | null
    nationCd: string
    name: string
    isMerchant: boolean
    isAdult: boolean
    emailAddress: string
    naverId: string
    birthday: string
    phoneNo: string
    age: number
}

export interface InternalMemberInfo {
    nickName: string | null
    name: string | null
    isMerchant: boolean
    isAdult: boolean
    emailAddress: string
    naverId: string
    birthday: string
    phoneNo: string
    age: number
    gender: 'm' | 'f'
    notRegistered?: boolean
}

export type SuccessMemberInfo = MemberInfo & {status: typeof MEMBER_STATUS.SUCCESS}

export type MemberInfoWithStatus =
    | SuccessMemberInfo
    | {status: typeof MEMBER_STATUS.NOT_AGREED}
    | {status: typeof MEMBER_STATUS.NONE}

export type InternalMemberInfoWithStatus =
    | (InternalMemberInfo & {status: typeof MEMBER_STATUS.SUCCESS})
    | {status: typeof MEMBER_STATUS.NOT_AGREED}
    | {status: typeof MEMBER_STATUS.NONE}

export interface MemberInfoExtends extends ApiGwResponse {
    result: MemberInfo
}

export interface LoginStatus {
    isLogin: boolean
    isSuccessLogin: boolean
    status?: ValueOf<typeof MEMBER_STATUS>
}
export interface UserInfo extends LoginStatus {
    naverId: string | null
    name: string | null
    nickName: string | null
    age: number
    gender: 'm' | 'f'
}
